import { render, staticRenderFns } from "./BadgeUpdate.vue?vue&type=template&id=02689850&"
import script from "./BadgeUpdate.vue?vue&type=script&lang=ts&"
export * from "./BadgeUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports